<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$store.state.theme.brand_color">
      <v-tab href="#holiday" ripple>Holiday</v-tab>
      <v-tab href="#WorkingHour" ripple>Working hour</v-tab>
      <v-tab href="#Consent" ripple>Consent</v-tab>
    </v-tabs>

    <component :is="currentView"></component>
  </div>
</template>

<script>
import holiday from './holiday.vue'
import WorkingHour from './WorkingHour.vue'
import Consent from './Consent.vue'
export default {
  data() {
    return {
      currentView: null
    }
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      vm.currentView = vm.$route.query.tab
    } else {
      vm.currentView = 'holiday'
    }
  },
  methods: {
    updateSlug() {
      var vm = this
      if (vm.currentView) {
        this.$router.replace({ query: { tab: vm.currentView } })
      }
    }
  },
  watch: {
    currentView: function () {
      this.updateSlug()
    }
  },
  components: {
    holiday,
    WorkingHour,
    Consent
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/generali/main.vue